

class SaleOption extends window.HTMLElement {
  constructor() {
    super();

    const data = document.querySelector(
      `script[data-product-json="${this.dataset.product}"]`
    );
    this.productData = data ? JSON.parse(data.innerHTML) : {};
    this.saleVariants = this.productData?.variants.filter(
      (variant) =>
        variant.compare_at_price && variant.price < variant.compare_at_price
    );
    this.colorIndex = this.productData.options.findIndex(
      (option) => option === 'Color'
    );
    this.swatches = this.querySelectorAll('[data-swatch]');
  }

  connectedCallback() {
    this.showSaleOptions();

    this.swatches.forEach((item) => {
      item.addEventListener('click', () => {
        const swatch = item.dataset.swatch;
        this.swatches.forEach((item) => item.removeAttribute('data-active'));
        item.setAttribute('data-active', '');
        const optionInput = document.querySelector(
          `[data-option-name="Color"] [data-swatch="${swatch}"]`
        );
        console.log(optionInput)
        if (optionInput) {
          optionInput.click();
        }
      });
    });
    //set unavailable swatches
    setTimeout(() => {
      document
        .querySelectorAll(
          'sticky-button input[type="radio"].is-unavailable'
        )
        .forEach((item) => {
          const saleItem = this.querySelector(
            `[data-swatch="${item.value.toLowerCase()}"]`
          );
          if (saleItem) {
            saleItem.classList.add('is-unavailable');
          }
        });
    }, 500);

    //check if all on sale
    const hasNoSaleVariant = [
      ...document.querySelectorAll(
        `[data-option-name="Color"] [data-swatch]`
      ),
    ];
    if (
      !hasNoSaleVariant.find(
        (item) => !item.classList.contains('!hidden')
      )
    ) {
      const variantOptionContainer = document.querySelector(
        '[data-option-name="Color"]'
      );
      if (variantOptionContainer) {
        variantOptionContainer.classList.add('hidden');
      }
    }
  }

  showSaleOptions() {
    if (this.colorIndex >= 0) {
      let colorOptions = this.saleVariants.map(
        (variant) => variant.options[this.colorIndex]
      );
      colorOptions = colorOptions.map((color) => color?.toLowerCase());
      const uniqueColorOptions = [...new Set(colorOptions)];
      this.swatches.forEach((item) => {
        if (uniqueColorOptions.includes(item.dataset.swatch?.toLowerCase())) {
          item.classList.remove('!hidden');
        } else {
          item.classList.add('!hidden');
        }
      });

      const currentColorOptions = document.querySelectorAll(
        '[data-option-name="Color"] [data-swatch]'
      );
      currentColorOptions.forEach((item) => {
        if (uniqueColorOptions.includes(item.dataset.swatch?.toLowerCase())) {
          item.classList.add('!hidden');
        } else {
          item.classList.remove('!hidden');
        }
      });
      //SET ACTIVE SWATCH
      const inputSelected = document.querySelector(
        '[data-option-name="Color"] input:checked+label'
      );
      if (inputSelected) {
        const swatch = inputSelected.dataset.swatch;
        const activeSwatch = this.querySelector(
          `[data-swatch="${swatch}"]`
        );
        if (activeSwatch) activeSwatch.setAttribute('data-active', '');
      }

      this.setAttribute('data-active', '');
    }
  }
}

window.customElements.define('sale-option', SaleOption);